import { environmentService } from '@core/services/Environment.service';

const API_PREFIX = 'pc';

const URL = {
  tokenRefresh: `/${API_PREFIX}/v1/auth/token/refresh`,
  connections: `/${API_PREFIX}/v1/connections`,
  users: `/${API_PREFIX}/v1/users`,
  login: `/${API_PREFIX}/v1/auth/login`,
  employeesLogin: `/${API_PREFIX}/v1/employees/login`,
  sendPasswordLink: `/${API_PREFIX}/v1/auth/password/reset`,
  resetPassword: `/${API_PREFIX}/v1/auth/password`,
  promptChainTemplate: `/${API_PREFIX}/v1/flows/node/template`,
  download: `/${API_PREFIX}/v1`,
  edge: `/${API_PREFIX}/v1/edges`,
  flow: `/${API_PREFIX}/v1/flows`,
  exportFlow: `/${API_PREFIX}/v1/flows/{{flowId}}/export`,
  flowV2: `/${API_PREFIX}/v2/flows`,
  acl: `/${API_PREFIX}/v1/acl`,
  roles: `/${API_PREFIX}/v1/roles`,
  permissions: `/${API_PREFIX}/v1/permissions`,
  apiUsers: `/${API_PREFIX}/v1/clients`,
  tokenVerification: `/${API_PREFIX}/v1/auth/token/verification`,
  oktaLoginPage: `/${API_PREFIX}/v1/auth/okta/login-page`,
  stopFlow: `/${API_PREFIX}/v1/runner/flow/`,
  files: `/${API_PREFIX}/v1/files`,
  microsoftLoginPage: `/${API_PREFIX}/v1/auth/azure/login`,
  flowCache: `/${API_PREFIX}/v1/runner/flow-cache/{{completedFlowId}}`,
  flowStream: `${environmentService.baseUrl}/${API_PREFIX}/v1/runner/run/flow`,
  restoreFlowStream: `${environmentService.baseUrl}/${API_PREFIX}/v1/runner/flow/{{id}}/stream`,
  nodeStream: `${environmentService.baseUrl}/${API_PREFIX}/v1/runner/run/node`,
  flowsChatStream: `${environmentService.baseUrl}/${API_PREFIX}/v1/flows`,
  assistant: `/${API_PREFIX}/v1/flows/{{flowId}}/assistant`,
  flowChatSettings: `/${API_PREFIX}/v1/flows/{{flowId}}/chat`,
  flowChatWebSocket: `${environmentService.baseUrl}/${API_PREFIX}/v1/flows`,
  userActionLogs: `/${API_PREFIX}/v1/user-action-logs`,
  userActionLogsExport: `/${API_PREFIX}/v1/user-action-logs/export`
} as const;

export { URL };
